// src/components/FilterBar.js
import React from 'react';

export default function FilterBar({ counts, value, onChange }) {
    const total = counts.reduce((s, c) => s + c.count, 0);

    return (
        <div style={{
            padding: '10px 12px',
            borderBottom: '1px solid #ccc',
            background: '#fafafa',
            flexShrink: 0
        }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>
                Filter by protocol
            </label>
            <select
                value={value}
                onChange={e => onChange(e.target.value)}
                style={{
                    width: '100%', padding: '6px 8px', fontSize: 13,
                    borderRadius: 4, border: '1px solid #aaa', background: '#fff'
                }}
            >
                <option value="">All protocols ({total})</option>
                {counts.map(c => (
                    <option key={c.name} value={c.name}>
                        {c.name} ({c.count})
                    </option>
                ))}
            </select>
        </div>
    );
}
